/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIMonthlyHistoryViewModel } from "../types/TutorAIMonthlyHistoryViewModel.ts";

export const tutorAIMonthlyHistoryViewModelSchema = z.object({
  yearMonth: z
    .string()
    .describe("Ano e mês de referência no formato yyyy-MM.")
    .nullish(),
  tokensUsed: z.optional(
    z.number().int().describe("Total de tokens consumidos no mês."),
  ),
}) as unknown as ToZod<TutorAIMonthlyHistoryViewModel>;
